<template>
  <dialogWrap v-model="show" title="违章管理配置" class="importBox">
    <div class="item">
      <span>
        风险预警：未处理分值大于等于
      </span>
      <el-input @input="(val) => this.scoreRules(val, 'riskScore', 999)" v-model="params.riskScore">
        <template slot="append">分</template>
      </el-input>
      <span>
        或未处理罚款大于
      </span>
      <el-input @input="(val) => this.scoreRules(val, 'riskFine', 9999)" v-model="params.riskFine">
        <template slot="append">元</template>
      </el-input>
      <span>
        或未处理违章数量大于
      </span>
      <el-input @input="(val) => this.scoreRules(val, 'riskViolationNum', 999)" v-model="params.riskViolationNum">
        <template slot="append">条</template>
      </el-input>
    </div>
    <div class="item">
      <span>
        高危预警：未处理分值大于等于
      </span>
      <el-input @input="(val) => this.scoreRules(val, 'highRiskScore', 999)" v-model="params.highRiskScore">
        <template slot="append">分</template>
      </el-input>
      <span>
        或未处理罚款大于
      </span>
      <el-input @input="(val) => this.scoreRules(val, 'highRiskFine', 9999)" v-model="params.highRiskFine">
        <template slot="append">元</template>
      </el-input>
      <span>
        或未处理违章数量大于
      </span>
      <el-input @input="(val) => this.scoreRules(val, 'highRiskViolationNum', 999)" v-model="params.highRiskViolationNum">
        <template slot="append">条</template>
      </el-input>
    </div>
    <div class="item">
      <span>
        超时预警：达到风险预警或高危预警，超过
      </span>
      <el-input v-number:integer="2" @input="(val) => this.scoreRules(val, 'overtimeDays', 99)" v-model="params.overtimeDays">
        <template slot="append">天</template>
      </el-input>
      <span>
        仍未处理完毕
      </span>
    </div>
    <template slot="footer">
      <el-button @click="close" size="small">取消</el-button>
      <el-button
        :loading="loading"
        type="primary"
        @click="addSubmit"
        size="small"
      >保存</el-button>
    </template>
  </dialogWrap>
</template>

<script>
import { configSaveViolationConfig, getByType } from '@/api/domain/carsService'

export default {
  model: {
    prop: 'showDialogWrap',
    event: 'change',
  },
  data() {
    return {
      show: false,
      params: {
        overtimeDays: 0, // 超时预警天数
        highRiskFine: 0, // 高危预警扣款数
        highRiskScore: 0, // 高危预警扣分数
        riskScore: 0, // 风险预警扣分数
        riskFine: 0, // 风险预警扣款数
      },
      loading: false,
    }
  },
  props: {
    showDialogWrap: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    showDialogWrap(val) {
      this.show = val
      if (val) {
        this.getByType()
      }
    },
    show(val) {
      this.$emit('change', val)
    },
  },
  methods: {
    // 分值、罚款 取值范围校验
    // eslint-disable-next-line vue/no-unused-properties
    scoreRules(val, type, max) {
      val = val.replace(/\D/g, '')
      if (val <= 0) {
        this.params[type] = 0
        return
      }
      if (val > max) {
        this.params[type] = max
        return
      }
      this.params[type] = Number(val)
    },
    getByType() {
      getByType({
        type: 1, // 1 违章风险 99 其他
      }).then((res) => {
        const { code, data } = res
        if (code === 1) {
          this.params = { ...data }
        }
      })
    },
    close() {
      this.show = false
    },
    addSubmit() {
      this.loading = true
      configSaveViolationConfig({
        ...this.params,
      }).then((res) => {
        this.loading = false
        const { code } = res
        if (code === 1) {
          this.$message.success('配置成功')
          this.$emit('selectBtn')
          this.close()
        }
      }).catch(() => {
        this.loading = false
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.item {
  display: flex;
  align-content: center;
  margin-bottom: 20px;

  span {
    display: flex;
    align-items: center;
  }
}

::v-deep .el-input {
  max-width: 140px;
}
</style>
